import React from 'react';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-navy-950 py-14 sm:py-20" data-id="element-287" data-mp="1twgvaqob8894">
      <div className="mx-auto w-full max-w-4xl px-5" data-id="element-288" data-mp="27mu56ykrhx13">
        <h2 className="font-display text-[1.7rem] font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-289" data-mp="27oeykkvcb9xd">
          If Any of These Situations Sound Familiar…
        </h2>
        <p className="mt-3 text-[1rem] font-semibold text-cyan-bright sm:text-lg" data-id="element-290" data-mp="2hix4zxs55jkv">
          Clinical Route for Erectile Dysfunction™ was designed for you.
        </p>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-291" data-mp="2qlg6adga3o50">
          {painPoints.map(point => <li key={point.text} className="flex gap-3.5 rounded-2xl border border-white/10 bg-navy-900 p-4 sm:p-5" data-id="element-292" data-mp="2mjbfdmh7t5m2">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-293" data-mp="w8ynpj6dxc6p">
                {point.emoji}
              </span>
              <p className="text-[0.92rem] leading-relaxed text-slate-300" data-id="element-294" data-mp="1n8brfvt3p9x9">
                {point.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl border border-white/10 bg-navy-900 p-5 sm:p-8" data-id="element-295" data-mp="1s4tumr8s907h">
          <p className="text-[0.7rem] font-bold uppercase tracking-[0.16em] text-slate-400" data-id="element-296" data-mp="1x4og2f9sgxl5">
            And here’s the reality…
          </p>
          <h3 className="mt-3 font-display text-xl font-extrabold leading-snug text-white sm:text-2xl" data-id="element-297" data-mp="26wc3m5385uhc">
            You shouldn’t feel like every patient starts from zero.
          </h3>
          <div className="mt-4 space-y-3 text-[0.95rem] leading-relaxed text-slate-300" data-id="element-298" data-mp="2fwqrnc7kpnoj">
            <p data-id="element-299" data-mp="2kvk6b7yljkqa">
              You shouldn’t have to rely entirely on memory to structure every
              erectile dysfunction consultation.
            </p>
            <p data-id="element-300" data-mp="lk0wkr5gy8fk">
              You shouldn’t need to jump between multiple guidelines every time
              a different clinical scenario appears.
            </p>
            <p data-id="element-301" data-mp="igbob94oldip">
              And you shouldn’t reduce a complex consultation to one question:{' '}
              <span className="font-semibold text-white" data-id="element-302" data-mp="eg1gdqxbwd17">
                “Which medication should I prescribe?”
              </span>
            </p>
            <p className="font-semibold text-cyan-bright" data-id="element-303" data-mp="scy4vlpz5iex">
              Because the decision starts much earlier.
            </p>
          </div>

          <ol className="mt-6 space-y-2 border-l-2 border-brand-500 pl-4" data-id="element-304" data-mp="11f7hqi8ptnvh">
            {['First, you need to understand the clinical scenario.', 'Then identify the factors that may influence it.', 'Then determine what information you need.', 'And finally establish the next clinical step.'].map(line => <li key={line} className="text-[0.92rem] text-slate-300" data-id="element-305" data-mp="1l3gi3fkex062">
                {line}
              </li>)}
          </ol>

          <p className="mt-6 text-[1rem] font-semibold leading-relaxed text-white" data-id="element-306" data-mp="1g5wqzf2m8swp">
            Because when you have a system, decisions stop depending entirely on
            memory. They start depending on a process.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-307" data-mp="1ps7tqv0pvikd">
          <CTAButton label="I want to stop guessing" note="7-day guarantee · No risk" data-id="element-308" data-mp="1prfxdhzapgt1" />
        </div>
      </div>
    </section>;
}